namespace $.$$ {

	$mol_style_define( $shm_ba_post_card, {
		display: 'grid',
		gap: '10px',
		minWidth: 0,
		border: {
			width: '1px',
			style: 'solid',
			color: $mol_theme.line,
			radius: '8px',
		},
		padding: '12px',

		Title: {
			font: {
				size: '18px',
				weight: 'bold',
			},
			minWidth: 0,
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
			overflow: 'hidden',
			lineHeight: '1.25',
			maxHeight: '2.5em',
		},

		Meta: {
			color: $mol_theme.shade,
			font: {
				size: '13px',
			},
			display: 'flex',
			flexWrap: 'wrap',
			gap: '4px',
		},

		Date_link: {
			display: 'inline',
			padding: 0,
			minHeight: 0,
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
		},

		Date_copy: {
			minWidth: 0,
			minHeight: 0,
			padding: '6px',
			margin: '-6px',
		},

		Source_link: {
			display: 'inline',
			padding: 0,
			minHeight: 0,
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
		},

		Source_copy: {
			minWidth: 0,
			minHeight: 0,
			padding: '6px',
			margin: '-6px',
		},

		Author_link: {
			display: 'inline',
			padding: 0,
			minHeight: 0,
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
		},

		Author_copy: {
			minWidth: 0,
			minHeight: 0,
			padding: '6px',
			margin: '-6px',
		},

		Tags: {
			display: 'flex',
			flexWrap: 'wrap',
			gap: '6px',
			color: $mol_theme.shade,
			font: {
				size: '13px',
			},
		},

		Tag: {
			display: 'inline-flex',
			alignItems: 'center',
			padding: {
				left: '8px',
				right: '8px',
				top: '2px',
				bottom: '2px',
			},
			border: {
				width: '1px',
				style: 'solid',
				color: '#78829638',
				radius: '6px',
			},
			backgroundColor: '#7882961A',
			color: $mol_theme.text,
			lineHeight: '1.3',
			whiteSpace: 'nowrap',
		},

		Text: {
			lineHeight: '1.45',
			whiteSpace: 'pre-wrap',
			overflowWrap: 'anywhere',
			overflow: 'hidden',
		},

		$mol_dimmer: {
			display: 'inline',
			High: {
				display: 'inline',
				backgroundColor: '#facc1538',
				color: $mol_theme.text,
				border: {
					radius: '3px',
				},
			},
			Low: {
				display: 'inline',
			},
		},

		Text_more: {
			justify: {
				self: 'start',
			},
			minHeight: 0,
			padding: {
				left: '8px',
				right: '8px',
				top: '4px',
				bottom: '4px',
			},
			'[disabled]': {
				true: {
					display: 'none',
				},
			},
		},

		Metrics: {
			display: 'flex',
			flexWrap: 'wrap',
			gap: [ '8px', '16px' ],
		},

		Metric: {
			color: $mol_theme.shade,
			font: {
				size: '13px',
			},
		},
	} )

}
